/* eslint-disable react-hooks/exhaustive-deps */
import { GlobalConfiguration } from "../../../../../utils/configurationProvider";
import globalText from "../../../../../utils/globalText";
import CommonLayout from "../../../../_utils/CommonLayout";
import Amount from "../../../../_utils/TransactionCommonComponents/Amount";
import PaymentMethodSelector from "../../../../_utils/TransactionCommonComponents/PaymentMethodSelector";
import "./index.css";

const InternalTransactionStepAmount = ({
  selectedRadioValue,
  txnPayLoad,
  isRtgs,
  handleNeftClick,
  handleRtgsClick,
  transactionLoading,
  amountInWords,
  reminder_remark,
  flow,
  copyData,
  setCopyData,
  COPY_KEYS,
  slideAnimation,
  handleDivBtn,
  handleAmountChange,
}) => {
  return (
    <div className="relative w-width-full">
      <div
        className={`relative z-z-index-content w-width-full max-w-screen-lg px-padding-md lg:px-padding-base snap-start justify-center Qmd:mt-margin-base ${reminder_remark !== null && flow === "ReminderFlow" ? "lg:pt-padding-md pt-padding-md" : "py-padding-md"} ${transactionLoading && "pointer-events-none"}`}
      >
        <CommonLayout>
          <Amount
            title={globalText?.AMOUNT}
            amount={txnPayLoad?.amount}
            amountInWords={amountInWords}
            copyData={copyData}
            onAmountChange={(val) =>
              handleAmountChange({ name: "amount", value: val })
            }
            onPasteApplied={() => {
              if (
                copyData?.title === COPY_KEYS.AMOUNT &&
                copyData?.data_type === "numeric"
              ) {
                const pastedValue = copyData?.value?.toString();
                handleAmountChange({
                  name: "amount",
                  value: pastedValue,
                });
              }
              setCopyData({ title: "", data_type: "", value: "" });
            }}
            sourceAmount={
              Number(txnPayLoad?.ownerBankBalance) >
              GlobalConfiguration.lengthCheckZero
                ? Math.abs(txnPayLoad?.ownerBankBalance)
                : undefined
            }
            destinationAmount={
              Number(txnPayLoad?.destinationAccountBalance) <
              GlobalConfiguration.lengthCheckZero
                ? Math.abs(txnPayLoad?.destinationAccountBalance)
                : undefined
            }
            isPreview={false}
            customAmountRequired={
              Number(txnPayLoad?.ownerBankBalance) ===
                GlobalConfiguration.lengthCheckZero &&
              Number(txnPayLoad?.destinationAccountBalance) ===
                GlobalConfiguration.lengthCheckZero
                ? false
                : (Number(txnPayLoad?.ownerBankBalance) >
                    GlobalConfiguration.lengthCheckZero &&
                    Number(txnPayLoad?.destinationAccountBalance) >
                      GlobalConfiguration.lengthCheckZero) ||
                  (Number(txnPayLoad?.ownerBankBalance) <=
                    GlobalConfiguration.lengthCheckZero &&
                    Number(txnPayLoad?.destinationAccountBalance) <=
                      GlobalConfiguration.lengthCheckZero) ||
                  (Number(txnPayLoad?.ownerBankBalance) >
                    GlobalConfiguration.lengthCheckZero &&
                    (Number(txnPayLoad?.destinationAccountBalance) <=
                      GlobalConfiguration.lengthCheckZero ||
                      isNaN(Number(txnPayLoad?.destinationAccountBalance))))
            }
            handleDivBtn={(val) => handleDivBtn(val)}
            selectedRadioValue={selectedRadioValue}
            flow="internlaTxnCustom"
          />

          <PaymentMethodSelector
            title={globalText?.SELECT_PAYMENT_METHOD}
            slideAnimation={slideAnimation}
            previewMode={false}
            methods={[
              {
                key: "neft",
                label: globalText?.NEFT,
                subText: globalText?.NEFT_TRANSFER_NOTE,
                active: !isRtgs,
                notes: [
                  globalText?.TRANSACTION_EXECUTION_NOTE,
                  globalText?.TRANSACTION_LIMIT_NOTE,
                  globalText?.TRANSACTION_CHARGES_NOTE,
                ],
                onClick: handleNeftClick,
              },
              {
                key: "rtgs",
                label: globalText?.RTGS,
                subText: globalText?.INSTANT_TRANSFER_NOTE,
                active: isRtgs,
                notes: [
                  globalText?.RTGS_TRANSACTION_EXECUTION_NOTE,
                  globalText?.RTGS_TRANSACTION_LIMIT_NOTE,
                  globalText?.TRANSACTION_CHARGES_NOTE,
                ],
                onClick: handleRtgsClick,
              },
            ]}
          />
        </CommonLayout>
      </div>
    </div>
  );
};

export default InternalTransactionStepAmount;
